const testRoutes = [];
if (process.env.NODE_ENV === 'development')
	testRoutes.push({
		path: 'myaccount/msajaxvuetest',
		props: route => ({ ...route.query, ...route.params }),
		component: () => import(/* webpackChunkName: 'Testing' */ './MsajaxVueTest.vue')
	});
export default testRoutes;
